import { connect } from "react-redux";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import { canManageTenantSettings } from "../../shared/tenantPermissions";
import { CompanySettingsViewModel } from "../../viewmodels/companySettings/CompanySettingsViewModel";
import CompanySettingsForm from "../../components/forms/company-settings/CompanySettingsForm";
import EmptyModal from "../../components/modals/EmptyModal";

function CompanySettingsForbidden() {
  return (
    <div className="min-h-[60vh] bg-surface px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl rounded-[18px] border border-border-subtle bg-card px-6 py-10 text-center shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
        <h1 className="text-2xl font-semibold text-brand">Access denied</h1>
        <p className="mt-3 text-sm leading-6 text-slate-500">
          Only company administrators can manage company settings. Contact your
          admin if you need access.
        </p>
        <a
          href="/dashboard"
          className="mt-6 inline-flex h-10 items-center justify-center rounded-xl border border-border-subtle bg-card px-4 text-sm font-semibold text-brand shadow-sm transition hover:bg-accent-soft"
        >
          Back to dashboard
        </a>
      </div>
    </div>
  );
}

function CompanySettingsLoading() {
  return (
    <div className="min-h-[40vh] bg-surface px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl animate-pulse space-y-6">
        <div className="h-28 rounded-[18px] bg-card" />
        <div className="h-72 rounded-[18px] bg-card" />
        <div className="h-72 rounded-[18px] bg-card" />
      </div>
    </div>
  );
}

function CompanySettings(props) {
  const {
    addSnackbar,
    logout,
    updateTenantSuccess,
    user_type,
    permissions,
    roles,
  } = props;

  const canManage = canManageTenantSettings(user_type, permissions, roles);

  const {
    emptyModal,
    setEmptyModelOpen,
    loading,
    saving,
    uploadingLogo,
    formValues,
    logoPreview,
    logoFile,
    updateField,
    resetChanges,
    handleLogoSelect,
    uploadLogo,
    saveSettings,
  } = CompanySettingsViewModel(addSnackbar, logout, updateTenantSuccess);

  if (!canManage) {
    return <CompanySettingsForbidden />;
  }

  return (
    <div className="min-h-screen bg-surface px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl space-y-6">
        <section className="rounded-2xl border border-border-subtle bg-card shadow-soft">
          <div className="border-b border-border-subtle px-6 py-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
              WIP Sync / Account
            </p>
            <h1 className="mt-2 text-[1.65rem] font-semibold tracking-tight text-brand sm:text-3xl">
              Company Settings
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500">
              Manage your company profile, branding, modules, and labels.
            </p>
          </div>
        </section>

        {loading || !formValues ? (
          <CompanySettingsLoading />
        ) : (
          <CompanySettingsForm
            formValues={formValues}
            logoPreview={logoPreview}
            logoFile={logoFile}
            saving={saving}
            uploadingLogo={uploadingLogo}
            updateField={updateField}
            resetChanges={resetChanges}
            handleLogoSelect={handleLogoSelect}
            uploadLogo={uploadLogo}
            saveSettings={saveSettings}
          />
        )}

        <EmptyModal
          childComponent={emptyModal.childComponent}
          open={emptyModal.open}
          setOpen={setEmptyModelOpen}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_type: state.auth.user_type,
    permissions: state.auth.permissions,
    roles: state.auth.roles,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    updateTenantSuccess: (tenant) =>
      dispatch(actions.updateTenantSuccess(tenant)),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CompanySettings),
);
